// Panda-pipeline AG-UI specifics not defined by the protocol package
// (`EventType` lives in @ag-ui/core). Shared across web and mobile.

export const AG_UI_TOOL = {
  SEARCH_KNOWLEDGE_BASE: 'search_knowledge_base', // internal retrieval, not rendered
  SHOW_DOC_ANSWER: 'show_doc_answer', // args stream the answer cards
  OFFER_HUB_ANSWER: 'offer_hub_answer', // knowledge-hub (ASA) fallback offer; args carry the variant
  SHOW_RELATED_RESOURCES: 'show_related_resources', // no-answer run: up to 5 related docs, most related first
} as const;

// activityType on ACTIVITY_SNAPSHOT events rendered as the status line.
export const AG_UI_ACTIVITY_TYPE = {
  STATUS: 'status',
} as const;

// Message roles on the AG-UI discriminated union. @ag-ui/core types these as
// literals but exports no constant; only the roles the panda client constructs
// or inspects are listed here.
export const AG_UI_ROLE = {
  USER: 'user',
  ASSISTANT: 'assistant',
  TOOL: 'tool',
  ACTIVITY: 'activity',
} as const;

// knowledge_hub_generation.source on the run state — which shared knowledge hub
// a fallback answer came from. ASA is the only source today; add sources here as
// the backend gains them.
export const HUB_SOURCE = {
  ASA: 'asa',
} as const;

export type AgUiTool = (typeof AG_UI_TOOL)[keyof typeof AG_UI_TOOL];
export type AgUiActivityType = (typeof AG_UI_ACTIVITY_TYPE)[keyof typeof AG_UI_ACTIVITY_TYPE];
export type AgUiRole = (typeof AG_UI_ROLE)[keyof typeof AG_UI_ROLE];
export type HubSource = (typeof HUB_SOURCE)[keyof typeof HUB_SOURCE];

const HUB_SOURCES = new Set<string>(Object.values(HUB_SOURCE));

/** A knowledge-hub source the client recognizes; else the run isn't a hub answer we render. */
export function isHubSource(value: unknown): value is HubSource {
  return typeof value === 'string' && HUB_SOURCES.has(value);
}
